<section class="map-drilldown-container">
  @if (isLoading) {
    <div class="map-loading"><span>Loading map data...</span></div>
  } @else {
    <div class="map-title-block">
      <!-- <div class="info-fields-container">
        @for (field of calculatedInfoFields; track field.fieldLabel) {
          <div class="info-field">
            <span class="field-label">{{ field.fieldLabel }}:- </span>
            <span class="field-value">{{ field.value }}</span>
          </div>
        }
      </div> -->
      <div class="map-title-content">
        <h4>{{ chartTitle }}</h4>
        @if (chartSubtitle) {
          <p>{{ chartSubtitle | camelCase }}</p>
        }
      </div>
      @if (activeExportConfig) {
        <div class="map-export-action">
          <app-download-button [tableValues]="exportRows" (buttonClicked)="downloadActionOnClick()"
            exportMessage="{{activeExportConfig.exportMessage}}"></app-download-button>
        </div>
      }
    </div>

    <highcharts-chart
      [Highcharts]="Highcharts"
      [constructorType]="chartConstructor"
      [options]="chartOptions"
      [(update)]="updateFlag"
      [oneToOne]="true"
      (chartInstance)="onChartInstance($event)"
      style="width: 100%; height: 500px; display: block;">
    </highcharts-chart>

    @if (selectedState) {
      <div class="dealer-panel">
        <div class="dealer-panel-header">
          <h4>Dealers in {{ selectedState }}</h4>
          <button class="close-btn" (click)="clearSelection()" title="Close">&#x2715;</button>
        </div>
        @if (selectedStateDealers.length === 0) {
          <p class="no-dealers">No dealers mapped to this state.</p>
        } @else {
          <div class="dealer-table-wrapper">
            <table class="dealer-table">
              <thead>
                <tr>
                  <th>#</th>
                  @for (column of tableColumns; track column.fieldKey) {
                    <th>{{ column.label }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (dealer of selectedStateDealers; track dealer.id; let i = $index) {
                  <tr>
                    <td class="rank">{{ i + 1 }}</td>
                    @for (column of tableColumns; track column.fieldKey) {
                      <td [class]="column.className ?? ''">
                        @if (column.valueType === 'regionBadge') {
                          <span class="region-badge" [attr.data-region]="getCellValue(dealer, column)">{{ getCellValue(dealer, column) }}</span>
                        } @else {
                          {{ formatCellValue(getCellValue(dealer, column), column) }}
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="dealer-panel-footer">
            <span>{{ selectedStateDealers.length }} Dealer{{ selectedStateDealers.length !== 1 ? 's' : '' }}
              &nbsp;|&nbsp; {{ mapConfig.footerMetricLabel }}: {{ selectedStateFooterMetric }}</span>
          </div>
        }
      </div>
    }
  }
</section>
